module.exports = __webpack_public_path__ + "media/images/icon__whatsapp-6a25708f89268aea2662879de9063e38.png";